"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _ArticleContent = _interopRequireDefault(require("./Article/ArticleContent"));

var _AnimatedIcons = _interopRequireDefault(require("../components/AnimatedIcons"));

var _Text = _interopRequireDefault(require("../components/Text"));

var _Container = _interopRequireDefault(require("../components/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Tabs = (0, _styled["default"])('div')(function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return {
    label: 'Tabs',
    backgroundColor: backgroundColor ? theme.colors[backgroundColor] || backgroundColor : theme.colors.smallLightGray
  };
});
var TabsContainer = (0, _styled["default"])(_Container["default"])(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({
    label: 'TabsContainer',
    '&:after': {
      display: 'block',
      content: '""',
      clear: 'both'
    }
  }, theme.media.tablet, {
    paddingTop: '50px',
    paddingBottom: '50px'
  });
});
var TabListWrapper = (0, _styled["default"])('div')(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty({
    label: 'TabListWrapper'
  }, theme.media.tablet, {
    marginTop: '30px',
    width: '20%',
    "float": 'left'
  });
});
var TabItemTitle = (0, _styled["default"])('div')(function (_ref6) {
  var theme = _ref6.theme,
      isSelected = _ref6.isSelected;
  return _defineProperty({
    position: 'relative',
    label: 'TabItemTitle',
    userSelect: 'none',
    width: '100%',
    textTransform: 'uppercase',
    color: theme.colors.primary,
    display: 'table',
    borderBottom: '1px solid #e5e5e5',
    height: '61px',
    textDecoration: 'none'
  }, theme.media.tablet, {
    color: theme.colors.black,
    paddingLeft: '0',
    paddingRight: '0',
    paddingTop: '0',
    display: 'block',
    textTransform: 'none',
    textDecoration: isSelected ? 'underline' : 'none',
    fontWeight: isSelected ? '700' : '300',
    height: 'auto',
    borderBottom: 0,
    paddingBottom: '30px'
  });
});
var TabItemInnerTitle = (0, _styled["default"])('div')({
  label: 'TabItemInnerTitle',
  display: 'table-cell',
  verticalAlign: 'middle',
  paddingLeft: '15px',
  paddingRight: '15px',
  fontSize: '14px',
  fontWeight: '700',
  cursor: 'pointer'
});
var StyledArticleContent = (0, _styled["default"])(_ArticleContent["default"])(function (_ref8) {
  var theme = _ref8.theme,
      selectedItem = _ref8.selectedItem;
  return _defineProperty({
    margin: '20px auto',
    display: selectedItem ? 'block' : 'none'
  }, theme.media.tablet, {
    display: 'none'
  });
});
var StyledAnimatedIcon = (0, _styled["default"])(_AnimatedIcons["default"].chevron)(function (_ref10) {
  var theme = _ref10.theme;
  return _defineProperty({
    color: theme.colors.primary,
    position: 'absolute',
    top: '30px',
    right: '0'
  }, theme.media.tablet, {
    display: 'none !important'
  });
});

var TabList = function TabList(_ref12) {
  var theme = _ref12.theme,
      items = _ref12.items,
      onSelectItem = _ref12.onSelectItem,
      selectedItem = _ref12.selectedItem;
  var tabletQuery = window.matchMedia("(min-width : ".concat(theme.breakpoints.tablet, "px)"));
  return _react["default"].createElement(TabListWrapper, null, items && items.map(function (tab, index) {
    return _react["default"].createElement("div", {
      key: index
    }, _react["default"].createElement(TabItemTitle, {
      onClick: function onClick() {
        return onSelectItem(index === selectedItem ? tabletQuery.matches ? selectedItem : -1 : index);
      },
      isSelected: index === selectedItem
    }, _react["default"].createElement(TabItemInnerTitle, null, tab.title), _react["default"].createElement(StyledAnimatedIcon, {
      size: 28,
      open: index === selectedItem
    })), _react["default"].createElement(StyledArticleContent, {
      key: index,
      selectedItem: selectedItem === index
    }, tab.content));
  }));
};

var TabContentInner = (0, _styled["default"])('div')(function (_ref13) {
  var theme = _ref13.theme;
  return _defineProperty({
    label: 'TabContentInner',
    display: 'none'
  }, theme.media.tablet, {
    display: 'block',
    width: '80%',
    "float": 'right',
    background: 'white'
  });
});
var TabContentWrapper = (0, _styled["default"])('div')(function (_ref15) {
  var theme = _ref15.theme;
  return {
    padding: '20px',
    border: "1px solid ".concat(theme.colors.lightGray),
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    borderRadius: 3
  };
});
var StyledHeading = (0, _styled["default"])(_Text["default"])(function (_ref16) {
  var theme = _ref16.theme;
  return {
    borderBottom: "1px solid ".concat(theme.colors.lightGray),
    paddingBottom: '30px',
    marginBottom: '20px'
  };
});

var TabContent = function TabContent(_ref17) {
  var tab = _ref17.tab;
  return _react["default"].createElement(TabContentInner, null, tab && tab.content ? _react["default"].createElement(TabContentWrapper, null, _react["default"].createElement(StyledHeading, {
    tag: "h3",
    size: "typo3"
  }, tab.title), _react["default"].createElement("div", null, tab.content)) : null);
};

var TabsContent =
/*#__PURE__*/
function (_Component) {
  _inherits(TabsContent, _Component);

  function TabsContent(props) {
    var _this;

    _classCallCheck(this, TabsContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabsContent).call(this, props));
    _this.onSelectItem = _this.onSelectItem.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedItem: typeof props.defaultIndex === 'number' ? props.defaultIndex : -1
    };
    return _this;
  }

  _createClass(TabsContent, [{
    key: "onSelectItem",
    value: function onSelectItem(tabIndex) {
      this.setState({
        selectedItem: tabIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          backgroundColor = _this$props.backgroundColor;
      return _react["default"].createElement(Tabs, {
        backgroundColor: backgroundColor
      }, _react["default"].createElement(TabsContainer, null, _react["default"].createElement(TabList, {
        items: items,
        onSelectItem: this.onSelectItem,
        selectedItem: this.state.selectedItem
      }), _react["default"].createElement(TabContent, {
        tab: items[this.state.selectedItem]
      })));
    }
  }]);

  return TabsContent;
}(_react.Component);

TabsContent.propTypes = {
  /**
   * Array of objects which contains a title and a content.
   */
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,

  /**
   * show the default's tab.
   */
  defaultIndex: _propTypes["default"].number,

  /**
   * Set a color for the Background color. By default, the color is light gray.
   */
  backgroundColor: _propTypes["default"].string
};
TabsContent.defaultProps = {
  backgroundColor: '#fafafa',
  items: []
};
var _default = TabsContent;
exports["default"] = _default;